var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcAppSidebarTab',{ref:"tab",attrs:{"id":_vm.id,"name":_vm.name,"icon":_vm.icon},on:{"bottomReached":_vm.onScrollBottomReached}},[(_vm.loading)?_c('NcEmptyContent',{attrs:{"icon":"icon-loading"}}):_vm._e(),_vm._v(" "),_c('div',{ref:"mount"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }